import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      content: {
        '[]': [
          {
            '{}': {
              name: {
                '++': [
                  {
                    '*': [
                      {
                        '@$': 'GrossMargin',
                      },
                      100,
                    ],
                  },
                  '% Gross Margin',
                ],
              },
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Base Salary',
                      value: {
                        '{}': {
                          aside: '/ Year',
                          emphasis: {
                            'fmt.num': [
                              {
                                '@$': 'BaseSalary',
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Fully Loaded Cost',
                      value: {
                        '{}': {
                          aside: '/ Year',
                          emphasis: {
                            'fmt.num': [
                              {
                                '*': [
                                  {
                                    '@$': 'BaseSalary',
                                  },
                                  {
                                    '+': [
                                      {
                                        '@$': 'Fringe',
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Cost of Service',
                      value: {
                        '{}': {
                          aside: '/ Hour',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '*': [
                                      {
                                        '@$': 'BaseSalary',
                                      },
                                      {
                                        '+': [
                                          {
                                            '@$': 'Fringe',
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    '@$': 'TotalHours',
                                  },
                                ],
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Bill Rate',
                      value: {
                        '{}': {
                          aside: '/ Hour',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '*': [
                                      {
                                        '@$': 'BaseSalary',
                                      },
                                      {
                                        '+': [
                                          {
                                            '@$': 'Fringe',
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    '*': [
                                      {
                                        '@$': 'TotalHours',
                                      },
                                      {
                                        '-': [
                                          1,
                                          {
                                            '@$': 'GrossMargin',
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                              '$',
                            ],
                          },
                          quality: 'good',
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
      name: 'Calculations',
      type: 'report-card',
    },
  },
}
